import { Handle, Position } from '@xyflow/react';
import CustomNode from './CustomNode';


const MultipleTargetNode = ({ data, isConnectable }) => {
  
    const moduleDetails = data.label.props.details;

  return (
    <div>
      <Handle
        type="target"
        position={Position.Top}
        isConnectable={isConnectable}
        id="b"
      />
        <CustomNode details={moduleDetails}/>
      <Handle
        type="target"
        position={Position.Left}
        id="a"
        isConnectable={isConnectable}
      />
      <Handle
        type="source"
        position={Position.Right}
        isConnectable={isConnectable}
      />
    </div>
  );
};

export default MultipleTargetNode;
